<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 70vw">
      <div class="modal-header">
        <h5 class="modal-title">Machine Parameters Tracking</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <div v-if="!loading" class="modal-body">
        <div class="form-grid">
          <div class="form-group">
            <label>Time Lapsed (min):</label>
            <input v-model="form.minutes_lapsed" type="number" min="0" />
          </div>
          <div class="form-group">
            <label>Blood Flow Rate (ml/min):</label>
            <input v-model="form.blood_flow_rate" type="number" step="0.1" />
          </div>
          <div class="form-group">
            <label>Dialysate Flow Rate (ml/min):</label>
            <input
              v-model="form.dialysate_flow_rate"
              type="number"
              step="0.1"
            />
          </div>
          <div class="form-group">
            <label>Venous Pressure (mmHg):</label>
            <input v-model="form.venous_pressure" />
          </div>
          <div class="form-group">
            <label>Arterial Pressure (mmHg):</label>
            <input v-model="form.arterial_pressure"/>
          </div>
          <div class="form-group">
            <label>Transmembrane Pressure (TMP) (mmHg):</label>
            <input v-model="form.tmp" />
          </div>
          <div class="form-group">
            <label>Conductivity (mS/cm):</label>
            <input v-model="form.conductivity" type="number" step="0.01" />
          </div>
          <div class="form-group">
            <label>Dialysate Temperature (°C):</label>
            <input
              v-model="form.dialysate_temperature"
              type="number"
              step="0.1"
            />
          </div>
        </div>
      </div>

      <div v-if="!loading" class="modal-footer">
        <button type="button" class="btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn-primary" @click="saveParams">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "./loader.vue";
import getElapsedMinutes from "./lapsed_minutes";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "MachineParametersModal",
  data() {
    return {
      form: {
        session_id: "",
        minutes_lapsed: "",
        blood_flow_rate: "",
        dialysate_flow_rate: "",
        venous_pressure: "",
        arterial_pressure: "",
        tmp: "",
        conductivity: "",
        dialysate_temperature: "",
      },
    };
  },
  components: {
    loader,
  },
  props: {
    session_id: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-machine-parameters-modal");
    },
    async getElapsedMinutes() {
      this.loading = true;
      const minutes = await getElapsedMinutes(this.session_id);
      this.form.minutes_lapsed = minutes;
      this.loading = false;
      return minutes;
    },
    async saveParams() {
      this.loading = true;
      this.form.session_id = this.session_id;
      // this.$emit("save-log", this.form);
      const req = await generalApiRequest(
        `machine-parameters`,
        "POST",
        this.form,
        1
      );

      console.log(req);
      this.closeModal();
      this.loading = false;
    },
  },
  mounted() {
    this.getElapsedMinutes();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(31, 31, 31, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.close {
  background: #e31919;
  border: none;
  color: white;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.4rem 0.7rem;
  cursor: pointer;
  border-radius: 0.3rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.2rem;
}

.form-group input {
  width: 100%;
  padding: 0.45rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.btn-primary {
  background: #2786f7;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}

.btn-secondary {
  background: #bbb;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}
</style>
